// /src/pages/private/members/dashboard/dashboardRankHistoryApi.js

import axios from 'axios';

/** @param {number} handleId */
export async function fetchDashboardRankHistory(handleId) {
  const { data } = await axios.post(
    '/api/user/private-dashboard/rank-history',
    { handleId },
    { withCredentials: true },
  );
  return data;
}
